export const UPDATE_COLOR = 'color:updateColor';

export function updateColor(newColor) {
  return {
    type: UPDATE_COLOR,
    payload: newColor
  }
}
